import React from "react";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import { Button } from "@mui/material";
import { getReadableAddress } from "./utils";

const MerchantInfoWindow = ({ merchant }) => {
  const name = merchant.name || "";
  const address = getReadableAddress(merchant.address || {});
  const searchQuery = [name, address].filter(Boolean).join(", ");
  const googleMapsSearchUrl = searchQuery
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(searchQuery)}`
    : "#";

  return (
    <div className="flex flex-column p-1 text-left w-64">
      <Typography variant="h6" sx={{ textAlign: "center" }}>
        {name}
      </Typography>
      <Divider sx={{ my: "6px" }} />
      <span>{address}</span>
      <Divider sx={{ my: "6px" }} />
      <Button
        href={googleMapsSearchUrl}
        target="_blank"
        rel="noopener noreferrer"
        variant="contained"
        size="small"
        fullWidth
        sx={{ marginTop: "12px" }}
      >
        View Location
      </Button>
    </div>
  );
};

export default MerchantInfoWindow;
